<template>
  <div>
    <p class="text-red text-size-18 font-bold">
      <i class='fa fa-exclamation-triangle' aria-hidden='true'></i>
      {{ `${total}点中${failedCount}点の商品が追加されませんでした` }}
    </p>
    <a class="text--underline" @click="downloadErrorReport">レポートをダウンロード</a>
  </div>
</template>

<script>
import SaleService from '@/services/salemasterservice'
import EventService from '@/services/eventservice'

export default {
  props: {
    total: {
      type: Number,
      default: 0
    },
    failedCount: {
      type: Number,
      default: 0
    },
    eventCode: {
      type: String,
      default: ''
    }
  },
  computed: {
    saleId () {
      return this.$route.params.saleId
    }
  },
  methods: {
    async downloadErrorReport () {
      const logParams = {
        name: this.eventCode,
        properties: {
          saleId: this.saleId
        }
      }
      EventService.postTrackLog(logParams)

      const sellerid = this.$store.getters.getUser.sellerId
      const filename = `Error_${sellerid}_${this.saleId}.csv`
      await SaleService.downloadErrorReport({ saleId: this.saleId }, filename)
        .catch(error => {
          this.$events.fire('handleError', error)
        })
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/sale/components/SaleEntryError.vue